import { Modal as AntdModal } from "antd";
import { ModalProps as AntdModalProps } from "antd/lib/modal";
import React, { ReactNode } from "react";

export interface MyModalProps extends AntdModalProps {
  children?: ReactNode;
}

export interface ModalStaticMethods {
  info: typeof AntdModal.info;
  success: typeof AntdModal.success;
  error: typeof AntdModal.error;
  warning: typeof AntdModal.warning;
  confirm: typeof AntdModal.confirm;
}

const ModalPolyfill: React.FC<MyModalProps> & ModalStaticMethods = ({
  children,
  ...props
}) => {
  return <AntdModal {...props}>{children}</AntdModal>;
};

ModalPolyfill.info = AntdModal.info;
ModalPolyfill.success = AntdModal.success;
ModalPolyfill.error = AntdModal.error;
ModalPolyfill.warning = AntdModal.warning;
ModalPolyfill.confirm = AntdModal.confirm;

export default ModalPolyfill;
